import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/core';

function Spinner(
  props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
) {
  let bars = [];

  for (let i = 0; i < 12; i++) {
    bars.push(
      <Bar
        key={i}
        style={{
          animationDelay: `${(i - 12) / 10}s`,
          transform: `rotate(${i * 30}deg) translate(146%)`,
        }}
      />,
    );
  }

  return <Container {...props}>{bars}</Container>;
}

const Container = styled.div`
  position: relative;
  width: 32px;
  height: 32px;
`;

const spin = keyframes`
 0% { opacity: 1; }
 100% { opacity: 0.15; }
`;

const Bar = styled.div`
  animation: ${spin} 1.2s linear infinite;
  border-radius: 5px;
  background-color: white;
  position: absolute;
  width: 20%;
  height: 7.8%;
  top: 46%;
  left: 40%;
`;

export default React.memo(Spinner);
